import { DictionaryEntry } from "./types";

export async function getDefinition(
    word: string, 
): Promise<DictionaryEntry[]> {
    const batch = (await import(`./definitions_${word.charAt(0)}`)).default;
    return batch[word] as DictionaryEntry[];
}